<template>
  <div>
    <TopHeader code="study" />

    <section class="uc-banner241">
      <div class="con">
        <h2>学习地图 培训体系的规划工具</h2>
        <div class="line"></div>
        <div class="txt">
          以能力发展路径和职业规划为主轴而设计的一系列学习活动，是员工在企业内学习发展路径的直接体现
        </div>
      </div>
    </section>

    <section class="container-fluid uc-learnMapList uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="title">我的学习地图</div>
          </div>
        </div>
        <div class="row list">
          <div
            class="col-24 col-sm-12"
            v-for="(item, index) in list.items"
            :key="index"
          >
            <router-link
              class="item"
              :to="{ name: 'LearningMapPath', params: { id: item.id } }"
            >
              <div class="con">
                <h3>{{ item.name }}</h3>
                <div class="line"></div>
                <div class="txt">
                  {{ item.description }}
                </div>
                <div class="btm">岗位数：{{ item.stage_count }}</div>
              </div>
              <div class="img img-box">
                <el-image :src="item.cover">
                  <div slot="error" class="image-slot">
                    <img src="../../assets/images/default-hd.png" />
                  </div>
                </el-image>
              </div>
              <span
                class="uc-tag"
                :class="item.progress == 100 ? 'blue' : 'orange'"
                >{{
                  item.progress == 100 ? '已完成' : `正在学习 ${item.progress}%`
                }}
              </span>
            </router-link>
          </div>
          <div class="col-24 col-sm-12">
            <div class="item">
              <div class="more">更多学习地图敬请期待......</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-24">
        <el-pagination
          class="uc-prvNxt"
          background
          layout="prev, pager, next"
          hide-on-single-page
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="list.total_count"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'LearningMap',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 9,
        keyword: undefined,
      },
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getLearningMaps();
    },
    async getLearningMaps() {
      const response = await this.$api.learningmap.getLearningMaps(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
  },
};
</script>
